// Shared constants for the Diamond Verification module.
// Extracted from /app/frontend/src/pages/DiamondVerification.jsx.

export const API = process.env.REACT_APP_BACKEND_URL;
export const token = () => localStorage.getItem('authToken');

export const COLORS    = ['D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
export const CLARITIES = ['VVS','VS','SI','I'];
export const LABS      = ['GIA','IGI','TDS'];

export const LAB_COLORS = {
  GIA: 'bg-emerald-600',
  IGI: 'bg-sky-600',
  TDS: 'bg-amber-600',
};

// Source badge — origin of the verified-diamond data
export const SOURCE_META = {
  manual:          { label: 'Manual',   tone: 'bg-gray-100 text-gray-700 border-gray-200' },
  erp:             { label: 'ERP',      tone: 'bg-indigo-100 text-indigo-700 border-indigo-200' },
  lab_certificate: { label: 'Lab Cert', tone: 'bg-amber-100 text-amber-700 border-amber-200' },
};

export const SHAPES = ['Round', 'Fancy'];

// Sieve size sets per shape (user-confirmed, Feb 2026)
// `3/4` added on both Round & Fancy to cover sieve letter L (70-85 cents).
// Baguette merged into Fancy — uses the same Fancy size letters.
export const SIZES_BY_SHAPE = {
  Round: ['0-6', '7-12', '1/6', '1/5', '1/4', '1/3', '3/8', '1/2', '3/4'],
  Fancy: ['-7',  '+7',   '1-10','1/6', '1/5', '1/4', '1/3', '3/8', '1/2', '3/4'],
};

export const STEP_TITLES = ['', 'Tag Assignment', 'Actual Diamond Data', 'TDS Visibility', 'Lab Proposal'];

export const MAX_PHOTOS = 3;
